export const LILITH_FOCUS_MODES = [
    {
        id: 'lilith-ombra',
        spread_slug: 'specchio-di-lilith',
        label: 'Lilith Ombra',
        description: 'Concentra la lettura sulle zone di ferita, catena e materiale rimosso.',
        highlighted_positions: [1, 3, 6],
        hidden_positions: [8],
        narrative_bias: 'shadow',
        overrides: {
            difficulty: 'advanced',
            ritual_note: 'Leggi solo il vettore di ombra: superficie, ferita e catena.',
        },
    },
    {
        id: 'lilith-desiderio',
        spread_slug: 'specchio-di-lilith',
        label: 'Lilith Desiderio',
        description: 'Evidenzia il triangolo desiderio-richiamo-verità erotico-spirituale.',
        highlighted_positions: [2, 4, 7],
        hidden_positions: [6],
        narrative_bias: 'ritual',
    },
    {
        id: 'lilith-potere',
        spread_slug: 'specchio-di-lilith',
        label: 'Lilith Potere',
        description: 'Legge il passaggio da ferita a potere represso, gesto rituale e integrazione.',
        highlighted_positions: [3, 5, 8, 9],
        narrative_bias: 'healing',
        overrides: {
            difficulty: 'initiatic',
        },
    },
    {
        id: 'lilith-relazione',
        spread_slug: 'specchio-di-lilith',
        label: 'Lilith Relazione',
        description: 'Rilegge il sistema come dinamica a due poli: maschera, desiderio, richiamo e verità.',
        highlighted_positions: [1, 2, 4, 7, 9],
        narrative_bias: 'relationship',
    },
    {
        id: 'lilith-iniziazione',
        spread_slug: 'specchio-di-lilith',
        label: 'Lilith Iniziazione',
        description: 'Percorre l’intero asse discensivo e asciensivo come rito completo.',
        highlighted_positions: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        narrative_bias: 'ritual',
        overrides: {
            difficulty: 'initiatic',
            opening_invocation: 'Discendo nello specchio e risalgo tenendo il centro.',
        },
    },
];
//# sourceMappingURL=lilith-focus.js.map